<template>
  <v-container style="max-width: 100%">
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-img class='align-center' :src="require('@/assets/images/sub.jpg')">
          <div class="text-center white--text py-5">
            <div class="text-sm-h3 pt-5 font-weight-bold" style="font-size: 1.5rem">운용상품 및 서비스</div>
            <div class="text-sm-h5 py-5" style="font-size: 1.0rem">인피니티투자자문의 운용상품 및 서비스를 소개합니다.</div>
          <!-- <div class='text-center white--text'><span class="sub_01">운용상품 및 서비스</span><br>
          <span class="sub_02">고객에게 신뢰받는 기업, 인피니티투자자문을 소개합니다.</span></div> -->
          </div>
        </v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-tabs
          v-model="model"
          centered
          slider-color="white"
          color="white"
          background-color="red darken-4"
          dark
          active-class="white red--text"
          replace
        >
          <v-tab
            v-for="(menu, i) in menus"
            :key="i"
            :href="`#tab-${i+1}`"
          >
            {{menu.title}}
          </v-tab>
        </v-tabs>

        <v-container>
          <div :class="$vuetify.breakpoint.mobile ? 'col-12 pa-0' : 'col-8 mx-auto'">
            <v-tabs-items v-model="model">
              <v-tab-item
                v-for="(menu, i) in menus"
                :key="i"
                :value="`tab-${i+1}`"
                eager
              >
                <v-card flat >
                  <v-img eager :src="menu.img" />
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      model: '',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
       menus: [
        { title: '운용상품', img: require('@/assets/images/menu2-1.jpg') },
        { title: '투자일임업이란?', img: require('@/assets/images/menu2-2.jpg') },
        { title: '서비스 과정', img: require('@/assets/images/menu2-3.jpg') },
        { title: '인피니티의 강점', img: require('@/assets/images/menu2-4.jpg') }

      ],
    }),
    created() {
      //this.model = this.$route.query.page;
    },
    mounted() {
      this.model = this.$route.query.page;
    }
  }
</script>

<style>
.v-tabs{
  margin-bottom: 80px; 

}

.v-tab.v-tab{
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: 0rem;
  padding: 0 60px;
}

.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), .theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, .theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn, .theme--dark.v-tabs > .v-tabs-bar .v-tab--disabled{
  color: #ffffff !important;
}

.sub_01{
  font-size:3.375rem ;
  font-weight: 700;
}
.sub_02{
  font-size:1.625rem;
}



</style>


